import axios from 'axios';
import React, { useEffect } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { LedgerType, PTOSnapshotType } from 'src/pages/pto/types';
import AxiosConfig from 'src/utilities/AxiosConfig';
import IconButton from '../common/IconButton';
import './PTOAddEditComments.css'

type PtoType = {
    ledger: Array<LedgerType>;
    pending: Array<number>;
    snapshot: PTOSnapshotType;
};

export interface IProps {
    showAddEditComments: boolean;
    setShowAddEditComments: Function;
    commentStatus: string;
    saving: boolean;
    isUpdating: boolean;
    setIsUpdating: Function;
    sortableData: LedgerType[];
    ptoData: PtoType
    setPtoData: Function;
    ledgerEntry: LedgerType;
    refreshData: Function
}

const PTOAddEditComments: React.FC<IProps> = (props) => {
    const   { showAddEditComments, setShowAddEditComments, commentStatus, saving, isUpdating, setIsUpdating, 
                sortableData, setPtoData , ptoData, ledgerEntry, 
            } =  props;
    const [editableEntry, setEditableEntry] = React.useState(ledgerEntry ? { ...ledgerEntry, } : {} as any);


    useEffect(() => {
        setPtoData(ptoData);
        //r-18-lint-cm
        //eslint-disable-next-line
    }, [ptoData])

    const closeAddEditComments = () => {
        setShowAddEditComments(!showAddEditComments)
    }

    const handleAddEditComments = (ledgerEntry: LedgerType, ptoData?: {
        ledger: Array<LedgerType>;
        pending: Array<number>;
        snapshot: PTOSnapshotType;
    }, closeTooltip?: any) => {
        let sortableDataCopy: Array<LedgerType> ;
        setIsUpdating(true);
        if (ledgerEntry) {
            let updatedEntry: LedgerType = { ...ledgerEntry };
            updatedEntry.EmployeeCommentDatets = Date.now();
            axios.post(process.env.REACT_APP_API_URL + "/api/pto/ledger", updatedEntry, AxiosConfig.configValue("min"))
                .then((res: any) => {
                    if (AxiosConfig.checkResponse(res, { alertOnSuccess: true, successMessage: "Updated Ledger Entry!", showSnackbar: true, snackBar: { manual: true } })) {
                        if(ptoData){
                            if(sortableData !== null && sortableData !== undefined){
                                sortableDataCopy = sortableData;
                                for(let j = 0; j < sortableDataCopy?.length; j++) {
                                    if(sortableDataCopy[j].ledgerId === updatedEntry.ledgerId){
                                        sortableDataCopy[j] = updatedEntry;
                                    }
                                }
                                setPtoData({ ...ptoData, ledger: sortableDataCopy });
                            }
                        }
                    }
                    closeAddEditComments();
                })
                .catch((err: any) => {
                    AxiosConfig.handleError(err);
                })
                .finally(() => { 
                    setIsUpdating(false);
                    props.refreshData()
                })
        } else {
            setIsUpdating(false);
        }
    }
    
    const handleCommentChange = (e: any) => {
        setEditableEntry({ ...editableEntry, [e.target.name]: e.target.value });
    }

    return(
        <Modal dialogClassName="pto-add-edit-comment-modal"  show={showAddEditComments}   >
            <Modal.Header>
                <h6>{commentStatus}</h6>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex flex-column col-12 mt-4">
                    <strong>Comments</strong>
                    <textarea name="employeeComment" onChange={handleCommentChange} style={{ minHeight: 100, minWidth: "50%" }} value={editableEntry.employeeComment || ""} />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <IconButton disabled={saving} onClick={() => closeAddEditComments()} buttonClassName="action-text-danger" icon="close">Close</IconButton>
                    {
                        isUpdating ?
                            <Spinner size="sm" animation="border" />
                            : <IconButton disabled={saving} showSpinner={saving} onClick={(e) => handleAddEditComments(editableEntry, ptoData)} buttonClassName="action-text" icon="save">
                                Save
                            </IconButton>
                    }
            </Modal.Footer>
        </Modal>
    )
}
export default PTOAddEditComments;